import React from "react";
import useSEO from "@/hooks/useSEO";

const Terms = () => {
  useSEO({
    title: "Terms of Service",
    description: "Shaurya Travels terms of service — booking conditions, cancellation policy, traveller responsibilities and liability terms.",
    path: "/terms",
  });

  return (
    <div data-testid="terms-page" className="pt-32 pb-20">
      <section className="max-w-3xl mx-auto px-6 lg:px-8">
        <p className="text-xs uppercase tracking-[0.4em] text-[var(--st-accent)] mb-4">— Legal</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl mb-3">Terms of Service</h1>
        <p className="text-sm text-[var(--st-ink-2)] mb-10">Last updated: January 2026</p>

        <div className="prose prose-sm max-w-none text-[var(--st-ink-2)] space-y-6 leading-relaxed">
          <p>
            These Terms of Service ("Terms") govern your use of the Shaurya Travels website
            <strong> https://shauryatravels.in</strong> and all tour, transport and travel
            services offered by Shaurya Travels ("we", "our", "us"). By using this site or booking
            with us, you agree to these Terms.
          </p>

          <h2 className="font-serif-display text-2xl text-[var(--st-ink)] mt-10 mb-3">1. About us</h2>
          <p>
            Shaurya Travels is a travel agency based in Pune, Maharashtra, India, offering curated
            tour packages, vehicle rentals (cars, SUVs, tempo travellers, buses, luxury coaches),
            airport transfers and customised travel planning across India and select international
            destinations.
          </p>

          <h2 className="font-serif-display text-2xl text-[var(--st-ink)] mt-10 mb-3">2. Booking & payment</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>All bookings are subject to availability at the time of confirmation.</li>
            <li>An advance payment (usually 25–50% of the total) is required to confirm a booking.</li>
            <li>The balance is payable before the start of the trip unless otherwise agreed.</li>
            <li>Payments may be made via bank transfer, UPI, or cash, as mutually agreed.</li>
            <li>All prices are inclusive of applicable GST unless stated otherwise.</li>
          </ul>

          <h2 className="font-serif-display text-2xl text-[var(--st-ink)] mt-10 mb-3">3. Cancellation & refund</h2>
          <p>If you need to cancel a confirmed booking:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>30+ days before departure: 90% refund of advance paid</li>
            <li>15–29 days before departure: 50% refund of advance paid</li>
            <li>7–14 days before departure: 25% refund of advance paid</li>
            <li>Less than 7 days: No refund (booking forfeited)</li>
          </ul>
          <p>
            Cancellation by us due to unavoidable circumstances (natural calamity, government
            restrictions, vehicle breakdown beyond replacement) will result in a full refund of
            payments received minus any non-refundable third-party charges (e.g., hotel deposits).
          </p>

          <h2 className="font-serif-display text-2xl text-[var(--st-ink)] mt-10 mb-3">4. Traveller responsibilities</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Carry valid government-issued photo ID for all travellers.</li>
            <li>Be punctual at pickup points; vehicles will not wait beyond 15 minutes.</li>
            <li>Inform us of any medical condition or special requirement at the time of booking.</li>
            <li>Behave courteously with our staff, drivers, and fellow travellers.</li>
            <li>Smoking and consumption of alcohol inside vehicles is prohibited.</li>
          </ul>

          <h2 className="font-serif-display text-2xl text-[var(--st-ink)] mt-10 mb-3">5. Liability</h2>
          <p>
            Shaurya Travels acts as a coordinator between you and third-party service providers
            (hotels, monuments, transport operators). We are not liable for:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Personal loss, injury or damage during the trip</li>
            <li>Delays, accidents or detours caused by traffic, weather, or third parties</li>
            <li>Loss of valuables — please carry them with you at all times</li>
            <li>Changes in itinerary due to circumstances beyond our reasonable control</li>
          </ul>
          <p>
            We strongly recommend that you take adequate travel insurance for the entire trip
            duration.
          </p>

          <h2 className="font-serif-display text-2xl text-[var(--st-ink)] mt-10 mb-3">6. Intellectual property</h2>
          <p>
            All content on this website — photographs, text, logo and design — is the property of
            Shaurya Travels and may not be reproduced or used without written permission.
          </p>

          <h2 className="font-serif-display text-2xl text-[var(--st-ink)] mt-10 mb-3">7. Governing law</h2>
          <p>
            These Terms are governed by the laws of India. Any dispute will be subject to the
            exclusive jurisdiction of the courts of Pune, Maharashtra.
          </p>

          <h2 className="font-serif-display text-2xl text-[var(--st-ink)] mt-10 mb-3">8. Contact</h2>
          <p>
            For any clarification on these Terms, please contact:<br />
            <strong>Shaurya Travels</strong><br />
            Email: <a href="mailto:shauryatravels1458@gmail.com" className="text-[var(--st-accent)]">shauryatravels1458@gmail.com</a><br />
            Phone: <a href="tel:+919371212211" className="text-[var(--st-accent)]">+91 9371212211</a><br />
            Pune, Maharashtra, India
          </p>
        </div>
      </section>
    </div>
  );
};

export default Terms;
